import { App } from "../../ts/app";
import { Controller } from "../../ts/controller";
import { Logger } from "../../ts/utils/logger";

export class ForumPostPageController extends Controller {

    constructor() {
        super({
            logLabel: 'ForumPostPageController',
        });
    }

    public initialize(): void {

        this._initializeListeners();
        this._setState();
        Logger.info(this.logLabel, 'Initialized');
    }

    private _initializeListeners() {
        if (App.loggedIn) {
            // TODO: initialize create-a-comment stuff
        }
        else {
            this.bindClick({
                elementId: 'forum-post-log-in-to-leave-comment-button',
                handler: () => {
                    window.loginDialogController.open(null);
                },
            });
        }
    }

    private _setState(): void {
    }
}